











































import VueOptions from '@utils/VueOptions'
import RequestButton from '@/components/RequestButton'
import states from '@assets/states.json'
import dma from '@assets/dma.json'

settings =
  name: 'AudienceListingResourceListPrimaryFilters'

  vue:
    props: ['filters', 'actions']

    data: ->
      state_options: states
      dma_options: dma

    methods:
      hiToggleFilter: ->
        @actions.hiFilterChange()

export default VueOptions.vue settings
